<template>
  <div class="col-md-12">
  <button class="btn" @click="backClick()">Volver</button>

    <time-line id="timeline">
      <template v-for="itemData in itemData">

        <template v-if="itemData.type=='viaje'">
          <time-line-item badgeType="success" badgeIcon="nc-icon nc-delivery-fast">
            <badge slot="header" type="success">{{itemData.type}}</badge>
            <div slot="content">
              <p class="itemBold"><b>Intervalo:</b> {{getIntervalText(itemData)}}</p>
              <p class="itemBold"><b>Recorrido:</b> {{(itemData.distance/1000).toFixed(1) + ' Km'}}</p>
              <p class="itemBold"><b>Velocidad Máx:</b> {{itemData.maxSpeed + ' Km/h' }}</p>
              <p><b>Dirección Inicio:</b> {{itemData.iniGeoRef.display_name}}</p>
              <p><b>Dirección de Fin:</b> {{itemData.endGeoRef.display_name}}</p>
            </div>
            <!-- <h6 slot="footer">
              <i class="ti-time"></i>
              Duración: {{convertSecsToHrsMins(itemData.duration)}}
            </h6> -->
          </time-line-item>
        </template>

        <template v-if="itemData.type=='parada'">
          <time-line-item class="timeline-inverted" badgeType="danger" badgeIcon="nc-icon nc-pin-3">
            <badge slot="header" type="danger">{{itemData.type}}</badge>
            <div slot="content">
              <p class="itemBold"><b>Intervalo:</b> {{getIntervalText(itemData)}}</p>
              <p ><b>Dirección:</b> {{itemData.iniGeoRef.display_name}}</p>
            </div>
            <!-- <h6 slot="footer">
              <i class="ti-time"></i>
              Duración: {{convertSecsToHrsMins(itemData.duration)}}
            </h6> -->
          </time-line-item>
        </template>

      </template>
    </time-line>
  </div>

</template>
<script>
  import TimeLine from '../../UIComponents/TimeLine/TimeLine'
  import TimeLineItem from '../../UIComponents/TimeLine/TimeLineItem.vue'
  import Badge from 'src/components/UIComponents/Badge.vue';
  import axios from 'axios'
  import reporteService from '../../../services/reporte'
  import {mapState} from 'vuex'

  export default {
    mounted () {
      this.getEvents()
      this.handleResize()
      window.addEventListener("resize", this.handleResize)
    },
    components: {
      TimeLine,
      TimeLineItem,
      Badge
    },
    computed: {
      ...mapState(['detalleReporte'])
    },
    data () {
      return {
        // events: [],
        // reportes: [{}],
        itemData: []
      }
    },
    methods: {
      getIntervalText(itemData) {
            let fromTo =  itemData.iniTs.split(" ")[1].substring(0,5) +'  -  ' + itemData.endTs.split(" ")[1].substring(0,5)
            let duracion = this.convertSecsToHrsMins(itemData.duration)
            return duracion + ' ( '+ fromTo + ' ) '
      },
      getEvents () {
        reporteService.detalleRecorridos(this.detalleReporte.patente, this.detalleReporte.idReporte).then(res=>{
          for (var itemIdx = 0; itemIdx < res.data.length; itemIdx++) {
            (this.itemData.push(JSON.parse(res.data[itemIdx].log_rep_item_data)))
          }
        })
      },
      backClick () {
        this.$router.go(-1)
      },
      convertSecsToHrsMins (secs) {
        let h = Math.floor(secs / 3600)
        let m = Math.floor((secs % 3600) / 60)
        h = h < 10 ? '0' + h : h
        m = m < 10 ? '0' + m : m
        return h + 'hr ' + m + 'min'
      },
      handleResize() {
        document.getElementById("content").style.height = "100%";
      }
    }
  }
</script>

<style>
.itemBold {
    font-size: 1.6em;
    margin-bottom: 2px;
}
</style>
